import { pxToRem } from 'utils/scss';

export const columnDetails = [
  {
    accessor: 'checkbox',
    contentType: 'checkBox',
    position: 'center',
    width: pxToRem('24px'),
    size: pxToRem('24px')
  },
  {
    accessor: 'leadId',
    headerType: 'text',
    contentType: 'linkLeadDetail',
    position: 'left',
    width: '1fr'
  },
  {
    accessor: 'type',
    headerType: 'text',
    contentType: 'text',
    position: 'left',
    width: '1fr',
    translated: true
  },
  /*  {
    accessor: 'name',
    contentType: 'text',
    headerType: 'text',
    position: 'left',
    width: '2fr'
  },
  {
    accessor: 'surname',
    contentType: 'text',
    headerType: 'text',
    position: 'left',
    width: '2fr'
  },*/
  {
    accessor: 'fullName',
    contentType: 'text',
    headerType: 'text',
    position: 'left',
    width: '2.4fr',
    sortable: true
  },
  {
    accessor: 'email',
    contentType: 'text',
    headerType: 'text',
    position: 'left',
    width: '2.4fr'
  },
  /*  {
    accessor: 'dealerCountry',
    contentType: 'text',
    headerType: 'text',
    position: 'left',
    width: '1fr'
  },*/
  /*{
    accessor: 'createdOn',
    contentType: 'text',
    headerType: 'text',
    position: 'left',
    width: '1fr'
  },*/
  {
    accessor: 'LastModifiedDate',
    headerType: 'text',
    contentType: 'text',
    position: 'left',
    width: '1.7fr',
    sortable: true
  },
  {
    accessor: 'status',
    headerType: 'text',
    contentType: 'status_menu',
    position: 'center',
    width: '2.5fr',
    translated: true
  },
  {
    accessor: 'true',
    contentType: 'icon',
    iconType: 'icon-pencil',
    position: 'right',
    size: '20',
    showOnHover: true,
    clickable: false,
    width: '0.2fr'
  }
];
